// extracted by mini-css-extract-plugin
export default {"item":"Item_item__6v2Nb","anchor":"Item_anchor__-J182","title":"Item_title__ChAVJ"};